import script from "./AppUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./AppUpload.vue?vue&type=script&setup=true&lang=js"

import "./AppUpload.vue?vue&type=style&index=0&id=a6a36832&lang=scss"

const __exports__ = script;

export default __exports__